(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    if (!window.__productReviewScrollBound) {
    window.__productReviewScrollBound = true;

    const reviewTarget = document.querySelector('[data-oke-widget]');
    if (!(reviewTarget instanceof HTMLElement)) return;

    const triggers = document.querySelectorAll('[data-review-scroll-trigger]');

    const scrollToReviews = () => {
      reviewTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    };

    for (const trigger of triggers) {
      if (!(trigger instanceof HTMLElement)) continue;

      trigger.setAttribute('data-review-link-enabled', 'true');
      trigger.setAttribute('role', 'link');
      trigger.setAttribute('tabindex', '0');

      trigger.addEventListener('click', scrollToReviews);
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        scrollToReviews();
      });
    }
  }
  } catch(e) { console.error(e); }
})();

})();
